import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
import cartSliceReducer from "./slices/cartSlice";
import stockCartReducer from "./slices/stockCartApiSlice";
import additionStockCartReducer from "./slices/stockAdditionApiSlice";
import stockIssueCartReducer from "./slices/stockIssueCartApiSlice";
import authReducer from "./slices/authSlice";
import languageReducer from "./slices/languageSlice";
import themeReducer from "./slices/themeSlice";
import notificationsReducer from "./notificationSlice";
import pcbCartReducer from "./slices/pcbCartSlice";
// 🆕 Sprint 1: Workflow Management
import jobReducer from "./slices/jobSlice";
import quoteReducer from "./slices/quoteSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    cart: cartSliceReducer,
    stockcart: stockCartReducer,
    additionstockcart: additionStockCartReducer,
    stockissuecart: stockIssueCartReducer,
    auth: authReducer,
    language: languageReducer,
    theme: themeReducer,
    notifications: notificationsReducer,
    pcbcart: pcbCartReducer,
    // 🆕 Sprint 1
    jobs: jobReducer,
    quotes: quoteReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;
